// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyCg04aSXkhvfMTdW2LTLZKDtZM2-Xro3Xw",
  authDomain: "sonicbot100-c9067.firebaseapp.com",
  databaseURL: "https://sonicbot100-c9067-default-rtdb.firebaseio.com",
  projectId: "sonicbot100-c9067",
  storageBucket: "sonicbot100-c9067.appspot.com",
  messagingSenderId: "20466279048",
  appId: "1:20466279048:web:c2fed22f3f42a183f1353d",
  measurementId: "G-3B5MY916PP"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const db = getFirestore(app);

export { auth, db };